module.exports = __webpack_public_path__ + "img/cancel.44a580fa.svg";